import styled, { CSSObject } from '@emotion/styled'
import { Box, Display1, ResponsiveValue, withCitrusTheme } from '@gousto-internal/citrus-react'

import bgImageDesktopJpeg from './assets/immersiveHero/desktop-background.jpg'
import bgImageDesktopWebp from './assets/immersiveHero/desktop-background.webp'
import bgImageMobileJpeg from './assets/immersiveHero/mobile-background.jpg'
import bgImageMobileWebp from './assets/immersiveHero/mobile-background.webp'
import bgDesktopCutoutPng from './assets/steamFX/desktop-cutout.png'
import bgDesktopCutoutWebp from './assets/steamFX/desktop-cutout.webp'
import bgMobileCutoutPng from './assets/steamFX/mobile-cutout.png'
import bgMobileCutoutWebp from './assets/steamFX/mobile-cutout.webp'

type ImageSet = {
  mobileImagePrimary: string
  mobileImageFallback: string
  desktopImagePrimary: string
  desktopImageFallback: string
}

const createBackgroundStyle = ({
  mobileImagePrimary,
  mobileImageFallback,
  desktopImagePrimary,
  desktopImageFallback,
}: ImageSet) => {
  // The webp image format is used as the primary image and the jpg format as fallback in case the browser doesn't support the webp image format.
  const responsiveValue: ResponsiveValue<string> = [
    `center/cover no-repeat url(${mobileImagePrimary}), center/cover no-repeat url(${mobileImageFallback})`,
    `15%/cover no-repeat url(${desktopImagePrimary}), 15%/cover no-repeat url(${desktopImageFallback})`,
    `4%/cover no-repeat url(${desktopImagePrimary}), 4%/cover no-repeat url(${desktopImageFallback})`,
    `120px/cover no-repeat url(${desktopImagePrimary}), 120px/cover no-repeat url(${desktopImageFallback})`,
  ]

  return responsiveValue
}

const mainBackgroundImageSet = {
  mobileImagePrimary: bgImageMobileWebp,
  mobileImageFallback: bgImageMobileJpeg,
  desktopImagePrimary: bgImageDesktopWebp,
  desktopImageFallback: bgImageDesktopJpeg,
}

const cutoutBackgroundImageSet = {
  mobileImagePrimary: bgMobileCutoutWebp,
  mobileImageFallback: bgMobileCutoutPng,
  desktopImagePrimary: bgDesktopCutoutWebp,
  desktopImageFallback: bgDesktopCutoutPng,
}

export const ContainerWithBackground = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(
    [...createBackgroundStyle(mainBackgroundImageSet)],
    ['background'],
  ) as CSSObject),
}))

export const ContainerWithGradient = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(
    [`linear-gradient(to top, #000000, #00000008 50%)`, 'none'],
    ['background'],
  ) as CSSObject),
}))

export const ContainerWithCutout = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(
    [...createBackgroundStyle(cutoutBackgroundImageSet)],
    ['background'],
  ) as CSSObject),
}))

export const HeroHeading = styled(Display1)`
  textshadow: '0px 2px 8px rgba(30, 30, 30, 0.5)';
`

export const SteamFXContainer = styled(Box)(() => ({
  [`@media (min-width: 1300px)`]: { right: '10%' },
  [`@media (min-width: 1400px)`]: { right: '15%' },
  [`@media (min-width: 1600px)`]: { right: '25%' },
}))
